import { render, staticRenderFns } from "./fruit-transfer-detail.vue?vue&type=template&id=1456e912&scoped=true&"
import script from "./fruit-transfer-detail.vue?vue&type=script&lang=js&"
export * from "./fruit-transfer-detail.vue?vue&type=script&lang=js&"
import style0 from "./fruit-transfer-detail.vue?vue&type=style&index=0&id=1456e912&prod&lang=scss&scoped=true&"
import style1 from "./fruit-transfer-detail.vue?vue&type=style&index=1&id=1456e912&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1456e912",
  null
  
)

export default component.exports